<template>
  <div>
    <SAIOrgHeader
      v-if="!isMobile"
      :org-contact-email="orgContactEmail"
      :org-contact-phone="orgContactPhone"
    />
    <SAIApplicationHeader
      :logo="logo"
      class="print-hide"
      :alert="alert"
      :profile-name="profileName"
      :profile-email="profileEmail"
      :org-contact-email="orgContactEmail"
      :org-contact-phone="orgContactPhone"
      :display-menu="isMobile"
      profile-icon="icon-person-outline"
      @logo:click="$emit('go:home')"
      @logout="$emit('logout')"
    >
      <QItem
        v-close-popup
        clickable
        v-if="isProfileSetupComplete"
        class="q-my-sm"
      >
        <QItemSection @click="$emit('open:profile-page')">
          <div class="row items-center">
            <QIcon name="eva-person-outline" size="21px" class="q-mr-sm" />
            <span>View Profile</span>
          </div>
        </QItemSection>
      </QItem>
      <QItem v-else class="q-my-sm">
        <QItemSection>
          <div class="row items-center no-wrap">
            <div class="col">
              <QIcon name="eva-person-outline" size="24px" class="q-mr-sm" />
            </div>
            <span class="q-mr-md">View Profile</span>
            <div class="rounded-borders q-pa-sm bg-primary-light">
              <span class="text-primary">
                {{ profileSetupCompletePercentage }}% completed
              </span>
            </div>
          </div>
          <QLinearProgress
            rounded
            track-color="grey-3"
            class="q-mt-md"
            color="primary"
            :value="
              profileSetupCompletePercentage
                ? profileSetupCompletePercentage / 100
                : 0
            "
          />
          <div>
            <SAIBtn
              class="q-mt-md rounded-borders-lg"
              :rounded="false"
              outline
              :no-caps="true"
              v-close-popup
              label="Complete Profile"
              padding="sm md"
              @click="$emit('open:profile-setup')"
            />
          </div>
        </QItemSection>
      </QItem>
      <QSeparator color="grey-3" v-if="canClearApplication" />
      <QItem v-if="canClearApplication">
        <QItemSection>
          <SAIBtn
            class="rounded-borders-lg"
            :rounded="false"
            outline
            :no-caps="true"
            color="negative"
            label="Clear application"
            :loading="clearingApplication"
            :disable="clearingApplication"
            padding="sm md"
            @click="$emit('clear:application')"
          />
        </QItemSection>
      </QItem>
    </SAIApplicationHeader>
  </div>
</template>

<script>
import {
  QItem,
  QItemSection,
  ClosePopup,
  QIcon,
  QLinearProgress,
  QSeparator
} from 'quasar';
import {
  SAIOrgHeader,
  SAIApplicationHeader,
  SAIBtn
} from 'ecx.saigon.ui.common';

export default {
  name: 'ApplicationHeader',
  props: {
    logo: String,
    profileName: String,
    profileEmail: String,
    orgContactEmail: String,
    orgContactPhone: String,
    alert: Number,
    isProfileSetupComplete: Boolean,
    profileSetupCompletePercentage: Number,
    canClearApplication: Boolean,
    clearingApplication: Boolean,
    isMobile: Boolean
  },
  directives: {
    ClosePopup
  },
  components: {
    QIcon,
    QItem,
    QItemSection,
    SAIOrgHeader,
    SAIApplicationHeader,
    QLinearProgress,
    SAIBtn,
    QSeparator
  }
};
</script>
